class EnvHelper {
  #audioSupportedExtension = null;
  #videoTransparentSupportedExtension = null;

  getAudioSupportedExtension() {
    if (this.#audioSupportedExtension) {
      return this.#audioSupportedExtension;
    }

    const audio = document.createElement("audio");
    if (audio.canPlayType('audio/mp4; codecs="mp4a.40.2"')) {
      this.#audioSupportedExtension = "m4a";
    } else {
      this.#audioSupportedExtension = "ogg";
    }

    return this.#audioSupportedExtension;
  }

  getVideoTransparentSupportedExtension() {
    if (this.#videoTransparentSupportedExtension) {
      return this.#videoTransparentSupportedExtension;
    }

    this.#videoTransparentSupportedExtension = "webm";

    const isSafari = this.testSafari();
    if (isSafari) {
      this.#videoTransparentSupportedExtension = "mov";
    }

    return this.#videoTransparentSupportedExtension;
  }

  testSafari() {
    return (
      navigator.vendor.match(/apple/i) &&
      !navigator.userAgent.match(/crios/i) &&
      !navigator.userAgent.match(/fxios/i)
    );
  }
}

const envHelper = new EnvHelper();
export { envHelper, EnvHelper };
